import { render } from "./GithubView.vue?vue&type=template&id=4a2c93d3"
import script from "./GithubView.vue?vue&type=script&lang=js"
export * from "./GithubView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__